// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { getFeaturedBrands } from "@vanmeter/App/Services/FeaturedBrandsService";
import { FeaturedBrandsModule, FeaturedBrandsParameter } from "@vanmeter/XDL/types";

type HandlerType = ApiHandlerDiscreteParameter<
    FeaturedBrandsParameter,
    FeaturedBrandsParameter,
    ServiceResult<FeaturedBrandsModule[]>
>;

export const DispatchBeginLoadFeaturedBrands: HandlerType = props => {
    props.dispatch({
        type: "xFeaturedBrands/StartLoading",
        parameter: props.parameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getFeaturedBrands(props.parameter);
};

export const DispatchCompleteLoadFeaturedBrand: HandlerType = props => {
    props.dispatch({
        type: "xFeaturedBrands/CompleteLoading",
        parameter: props.parameter,
        featuredBrands: props.apiResult.successful ? props.apiResult.result : [],
    });
};

export const chain = [DispatchBeginLoadFeaturedBrands, RequestDataFromApi, DispatchCompleteLoadFeaturedBrand];

const loadFeaturedBrands = createHandlerChainRunner(chain, "loadFeaturedBrands");
export default loadFeaturedBrands;
